import {
  FieldTypes,
  BelongsCreatedByRefField,
  level3ReferenceField,
  level3ReferenceField2,
  byFields,
} from 'drapcode-constant';
const { createdBy, updatedBy } = FieldTypes;

export const CUSTOM_SEPARATOR = `##@CUSTOM_SEPARATOR@##`;
export const pluginDefaultFields = [
  'tenantId',
  'userSettingId',
  'subTenantId',
  'permissions',
  'userRoles',
  'passwordResetAttempts',
  'lastResetReqAt',
  'isSuperAdmin',
  'loginAttempts',
  'lastLoginAttemptAt',
  'emailOtp',
  'emailOtpExpiry',
  'emailOtpToken',
  'smsOtp',
  'smsOtpExpiry',
  'smsOtpToken',
  'emailConsentBy',
  'emailConsentAt',
  'smsConsentBy',
  'smsConsentAt',
];

export const extractRefCollectionField = (fields, collections) => {
  if (!fields || fields.length === 0) {
    return [];
  }
  const referenceFields = fields.filter((field) => BelongsCreatedByRefField.includes(field.type));
  if (!referenceFields || referenceFields.length === 0) {
    return [];
  }
  return referenceFields;
};

export const extractRefField = (
  fields,
  collections,
  dataTypes = [],
  multi = true,
  showReferenceFieldInRF = false,
) => {
  if (!fields || fields.length === 0) {
    return '';
  }
  let nestedFields = [];
  let referenceFields = extractRefCollectionField(fields);
  if (showReferenceFieldInRF) {
    referenceFields.forEach((field) => {
      nestedFields.push({
        fieldName: `${field.fieldName}`,
        fieldTitle: `${field.fieldTitle.en}`,
      });
    });
  }
  if (!multi) referenceFields = referenceFields.filter((field) => !field.isMultiSelect);
  referenceFields.map((field) => {
    let { collectionName } = field.refCollection;
    let refFields = [];
    const referenceCollection = collections
      ? collections.find((e) => e.collectionName === collectionName)
      : null;
    if (!referenceCollection) {
      return nestedFields;
    }
    if (!referenceCollection.fields) {
      return nestedFields;
    }

    refFields = referenceCollection.fields.filter((e) => {
      if (dataTypes.length > 0)
        return !level3ReferenceField.includes(e.type) && dataTypes.includes(e.type);
      return !level3ReferenceField.includes(e.type);
    });
    refFields = refFields.map((nestedField) => {
      const parentFieldName = field.fieldName;
      const childFieldName = nestedField.fieldName;
      const parentFieldLabel = field.fieldTitle.en;
      const childFieldLabel = nestedField.fieldTitle.en;
      return {
        fieldName: `${parentFieldName}.${childFieldName}`,
        fieldTitle: `${parentFieldLabel}:${childFieldLabel}`,
      };
    });
    nestedFields = [...nestedFields, ...refFields];
  });
  return nestedFields;
};

export const extractRefFieldForCreateField = (
  fields,
  collections,
  index,
  dataTypes = [],
  multi = true,
) => {
  if (!fields || fields.length === 0) {
    return '';
  }
  const parentCollection = index ? collections[index] : '';
  let nestedFields = [];
  fields.map((field) => {
    let { collectionName } = field.refCollection;
    let refFields = [];
    let updatedRefFields = [];
    const referenceCollection = collections
      ? collections.find((e) => e.collectionName === collectionName)
      : null;
    if (!referenceCollection) {
      return nestedFields;
    }
    if (!referenceCollection.fields) {
      return nestedFields;
    }

    refFields = referenceCollection.fields.filter((e) => {
      if (dataTypes.length > 0)
        return !level3ReferenceField.includes(e.type) && dataTypes.includes(e.type);
      return !level3ReferenceField.includes(e.type);
    });

    refFields.map((nestedField) => {
      let parentFieldName = field.fieldName;
      let childFieldName = nestedField.fieldName;
      let parentFieldLabel = field.fieldTitle.en;
      let childFieldLabel = nestedField.fieldTitle.en;

      // Deep copy
      let refField = _.cloneDeep(nestedField);
      refField['fieldName'] = `${parentFieldName}.${childFieldName}`;
      refField['fieldTitle']['en'] = `${parentFieldLabel}:${childFieldLabel}`;

      if (refField['refCollection']) {
        refField['refCollection']['collectionName'] = parentCollection
          ? parentCollection.collectionName
          : '';
        refField['refCollection']['collectionField'] = childFieldName;
        refField['refCollection']['childRefCollectionName'] = collectionName;
      } else {
        refField['refCollection'] = {
          collectionName: parentCollection ? parentCollection.collectionName : '',
          collectionField: childFieldName,
          parentCollectionField: '',
          childRefCollectionName: collectionName,
          displayType: 'dropdown',
          isShowAsText: false,
          isShowAsRadioOrCheckBox: false,
          isFileType: false,
        };
      }

      updatedRefFields.push(refField);
    });
    nestedFields = [...nestedFields, ...updatedRefFields];
  });
  return nestedFields;
};

export const getInnerFieldOptions = (fields, collections, fieldFrom, fieldType, from) => {
  const referenceFields = extractRefCollectionField(fields);

  let nestedFields = [];
  referenceFields.map((field) => {
    if (byFields.has(field.type) && !field.refCollection) {
      field.refCollection = {
        collectionName: 'user',
        collectionField: 'userName',
        displayType: 'dropdown',
      };
    }
    let { collectionName } = field.refCollection;
    let refFields = [];
    const refrenceCollection = collections
      ? collections.find((e) => e.collectionName === collectionName)
      : null;
    if (!refrenceCollection) {
      return nestedFields;
    }

    if (!refrenceCollection.fields) {
      return nestedFields;
    }

    const { fields } = refrenceCollection;
    let fieldFilters = [];
    if (fieldType) {
      fieldFilters = [fieldType];
    } else {
      fieldFilters = level3ReferenceField2;
    }
    refFields = fields
      .filter((e) => {
        if (fieldType) {
          return fieldFilters.includes(e.type);
        } else {
          return !fieldFilters.includes(e.type);
        }
      })
      .map((nestedField) => {
        const parentFieldName = field.fieldName;
        const childFieldName = nestedField.fieldName;
        const parentFieldLabel = field.fieldTitle.en;
        const childFieldLabel = nestedField.fieldTitle.en;

        if (fieldType) {
          if (from === 'fromEvent') {
            const fieldData = {
              fieldFrom: fieldFrom,
              fieldName: `${parentFieldName}.${childFieldName}`,
              collectionName: refrenceCollection.collectionName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: `${parentFieldLabel}:${childFieldLabel}`,
            };
          } else if (from === 'fromEmail') {
            const fieldData = {
              fieldFrom,
              fieldName: `${parentFieldName}.${childFieldName}`,
            };
            return {
              value: JSON.stringify(fieldData),
              label: `${parentFieldLabel}:${childFieldLabel}`,
            };
          }
        } else {
          return {
            fieldName: `${parentFieldName}.${childFieldName}`,
            fieldTitle: `${parentFieldLabel}:${childFieldLabel}`,
          };
        }
      });

    nestedFields = [...nestedFields, ...refFields];
  });
  return nestedFields;
};

export const renderDefaultFieldType = (fieldName) => {
  let defaultFieldType = '(system default)';
  switch (fieldName) {
    case 'tenantId':
      defaultFieldType = '(tenant default)';
      break;
    case 'userSettingId':
    case 'userId':
      defaultFieldType = '(User settings default)';
      break;
    case 'permissions':
      defaultFieldType = '(Permissions Default)';
      break;
    case 'userRoles':
      defaultFieldType = '(Roles Default)';
      break;
    case 'subTenantId':
      defaultFieldType = '(Sub Tenant Default)';
      break;
    default:
      break;
  }
  return defaultFieldType;
};

export const extractDefaultCollectionFields = (fields, fieldName, defaultCollectionFields) => {
  if (!fields) {
    return;
  }
  const field = fields.find((field) => field.isPluginField && field.fieldName === fieldName);
  if (field) {
    defaultCollectionFields.push({
      order: defaultCollectionFields.length + 1,
      defaultField: field,
    });
  }
};
